import React, { useState } from 'react'
import { isAxiosError } from 'axios'
import {
  Box,
  Button,
  Flex,
  Label,
  Loading,
  Modal,
  Text,
  Tooltip,
} from '@workwhile/ui'
import { useJetTimesheetPhoto } from 'queries/jet/useJetTimesheetPhoto'

export const JetTimesheetPhotoCell = ({
  associationId,
  hasTimesheetPhoto,
  timesheetPhotoIsFallback,
}: {
  associationId: number
  hasTimesheetPhoto: boolean
  timesheetPhotoIsFallback: boolean
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false)

  const {
    data: photoUrl,
    isLoading: photoLoading,
    isError: photoError,
    error: photoErrorObj,
    refetch: refetchPhoto,
  } = useJetTimesheetPhoto(associationId, { enabled: isModalOpen })

  const photoForbidden =
    isAxiosError(photoErrorObj) && photoErrorObj.response?.status === 403

  if (!hasTimesheetPhoto) {
    return <Text color="lightText">-</Text>
  }

  return (
    <>
      <Flex alignItems="center" gap={2} flexWrap="wrap">
        <Button
          kind="small"
          variant="secondary"
          onClick={() => setIsModalOpen(true)}
          style={{ padding: '0 0.5rem' }}
        >
          View timesheet
        </Button>
        {timesheetPhotoIsFallback ? (
          <Tooltip content="No worker photo was submitted. This is an automatically generated proof-of-work image from HyperTrack.">
            <Box as="span">
              <Label
                variant="information"
                size="small"
                style={{ whiteSpace: 'nowrap', padding: '0 0.5rem' }}
              >
                HyperTrack
              </Label>
            </Box>
          </Tooltip>
        ) : null}
      </Flex>
      <Modal
        open={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        {...({ width: 'auto', maxWidth: '90vw' } as any)}
      >
        {photoLoading ? (
          <Loading />
        ) : photoUrl ? (
          <Box>
            {timesheetPhotoIsFallback ? (
              <Text color="lightText" mb={2}>
                Auto-generated proof-of-work photo (no worker upload)
              </Text>
            ) : null}
            <img
              src={photoUrl}
              alt="JET Timesheet"
              style={{
                maxWidth: '85vw',
                maxHeight: '85vh',
                objectFit: 'contain',
              }}
            />
          </Box>
        ) : photoForbidden ? (
          <Text color="danger">
            You don&apos;t have permission to view this photo.
          </Text>
        ) : photoError ? (
          <Button variant="secondary" onClick={() => refetchPhoto()}>
            Retry
          </Button>
        ) : null}
      </Modal>
    </>
  )
}
